define.alias("ember-cli-string-helpers/helpers/trim", "settings/helpers/trim");